__turbopack_context__.v({
  "container": "MYlCOG_container",
  "submitting": "MYlCOG_submitting",
});
